import Browser from '@mindful-web/marko-web/browser';
import Shared from '@ascend-media/package-daily/browser';

Shared(Browser);

export default Browser;
